import '@popperjs/core/dist/umd/popper.js'
import 'bootstrap/dist/js/bootstrap.js'
import '@hotwired/turbo-rails' // Turbo

import '../controllers' // Stimulus controllers
import { initAnalytics } from '../app/modules/analytics'

// PostHog reconciles identity on every load; pageviews are captured natively via
// capture_pageview: 'history_change'
document.addEventListener('turbo:load', () => initAnalytics())
